import React, { useState } from 'react';
import { useGlobal } from '../context/GlobalContext';
import { Proveedor } from '../types';
import { eliminarProveedor } from '../services/proveedores';
import ProveedorForm from '../components/ProveedorForm';
import DeleteWarning from '../components/DeleteWarning';
import '../styles/Ubicaciones.css'; // Reusing Ubicaciones CSS for consistency

const Proveedores: React.FC = () => {
    const { data, loading, reLoad } = useGlobal();
    const proveedores: Proveedor[] = data?.proveedores || [];

    const [modalData, setModalData] = useState<any>(null); // { type: 'Agregar' | 'Editar' | 'Eliminar', item?: Proveedor }
    const [modalOpen, setModalOpen] = useState(false);
    const [alertMessage, setAlertMessage] = useState<string>('');

    const handleClose = () => {
        setModalOpen(false);
        setModalData(null);
    };

    const handleSuccess = (msg: string) => {
        setAlertMessage(msg);
        handleClose();
        reLoad();
        setTimeout(() => setAlertMessage(''), 5000);
    };

    const handleAdd = () => {
        setModalData({ type: 'Agregar' });
        setModalOpen(true);
    };

    const handleEdit = (item: Proveedor) => {
        setModalData({ type: 'Editar', item });
        setModalOpen(true);
    };

    const handleConfirmDelete = (item: Proveedor) => {
        setModalData({ type: 'Eliminar', item });
        setModalOpen(true);
    };

    const handleDelete = async () => {
        if (modalData?.item) {
            try {
                await eliminarProveedor(modalData.item.id);
                handleSuccess("Proveedor eliminado correctamente");
            } catch (error: any) {
                handleSuccess('Error al eliminar, posiblemente tiene asociadas facturas o compras activas');
            }
        }
    };

    return (
        <div className="ubicaciones-page">
            <h2 className="text-2xl font-bold mb-4">Gestión de Proveedores</h2>

            {alertMessage && (
                <div className={`alert ${alertMessage.includes('Error') ? 'alert-danger' : 'alert-success'}`}>
                    {alertMessage}
                </div>
            )}

            <button className="button primary mb-4" onClick={handleAdd} style={{ marginBottom: '20px' }}>
                + Nuevo Proveedor
            </button>

            {loading ? <p>Cargando proveedores...</p> : (
                <div className="table-responsive">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Nombre Comercial</th>
                                <th>Contacto</th>
                                <th>Teléfono</th>
                                <th style={{ width: '200px' }}>Acciones</th>
                            </tr>
                        </thead>
                        <tbody>
                            {proveedores.map((p) => (
                                <tr key={p.id}>
                                    <td>{p.id}</td>
                                    <td style={{ fontWeight: 600 }}>{p.nombre}</td>
                                    <td>{p.contacto || '-'}</td>
                                    <td>{p.telefono || '-'}</td>
                                    <td>
                                        <button className="button secondary small" onClick={() => handleEdit(p)}>
                                            Editar
                                        </button>
                                        <button 
                                            className="button danger small" 
                                            onClick={() => handleConfirmDelete(p)} 
                                            style={{ marginLeft: '5px', backgroundColor: '#dc3545', color: 'white', border: 'none' }}
                                        >
                                            Eliminar
                                        </button>
                                    </td>
                                </tr>
                            ))}
                            {proveedores.length === 0 && (
                                <tr>
                                    <td colSpan={5} style={{ textAlign: 'center', padding: '20px' }}>No hay proveedores registrados. Inicie agregando uno nuevo.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            )}

            {modalOpen && (
                <div className="modal">
                    <div className="modal-content">
                        {(modalData.type === 'Agregar' || modalData.type === 'Editar') && (
                            <ProveedorForm
                                onClose={handleClose}
                                onSuccess={handleSuccess}
                                itemData={modalData.item}
                            />
                        )}
                        {modalData.type === 'Eliminar' && (
                            <DeleteWarning
                                itemType="Proveedor"
                                itemName={modalData.item.nombre}
                                onCancel={handleClose}
                                onConfirm={handleDelete}
                            />
                        )}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Proveedores;
